export default __webpack_public_path__ + "static/media/casaclub.0447e2e3.svg";